import styled from 'styled-components'

export const Header = styled.div`
  border: 2px solid #ffffff;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (min-width: 768px) {
    width: 900px;
    margin: auto;
  }
`

export const TitleContainer = styled.div``

export const Title = styled.h1`
  font-family: 'Bree Serif';
  font-size: 18px;
  color: #ffffff;

  @media screen and (min-width: 768px) {
    font-size: 28px;
  }
`

export const ScoreBox = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px 20px;
  text-align: center;
`

export const ScoreText = styled.p`
  font-family: 'Bree Serif';
  font-size: 14px;
  color: #223a5f;
  margin: 0;

  @media screen and (min-width: 768px) {
    font-size: 20px;
  }
`

export const ScoreValue = styled.p`
  font-family: 'Roboto';
  font-size: 22px;
  color: #223a5f;
  margin: 0;

  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`
